//https://developers.google.com/youtube/iframe_api_reference#Getting_Started
export default {
  data() {
    return {
      video_div: null,
      videoIO: null,
      isVideoViewable: false
    };
  },
  methods: {
    addYtPlayer(target, videoId, width, height) {
      let div = document.createElement("div");
      div.id = "video-div";
      let ytplayer = document.createElement("div");
      ytplayer.id = "player";
      div.appendChild(ytplayer);
      target.appendChild(div);
      this.video_div = div;

      let player = new YT.Player(ytplayer, {
        width: width,
        height: height,
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          mute: 1,
        },
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange,
        },
      });
      this.videoIO = new IntersectionObserver(
        (entries) => {
          if (entries.length) {
            if (entries[0].isIntersecting) {
              this.isVideoViewable = true;
              player.playVideo();
            } else {
              this.isVideoViewable = false;
              player.pauseVideo();
            }
          }
        },
        { threshold: 0.5 }
      );

      this.addEvent(window, "visibilitychange", () => {
        if (!this.isPageHidden() && this.isVideoViewable) {
          player.playVideo();
        } else {
          player.pauseVideo();
        }
      });
      return player;
    },
    onPlayerReady(e) {
      console.log(e.target.getDebugText());
      if (this.creative._type !== 'rollingCastle') {
        this.videoIO.observe(this.video_div);
      }
    },
    onPlayerStateChange(e) {
      //e.data
      // -1 (unstarted)
      // 0 (ended)
      // 1 (playing)
      // 2 (paused)
      // 3 (buffering)
      // 5 (video cued).
      // YT.PlayerState.ENDED
      // YT.PlayerState.PLAYING
      // YT.PlayerState.PAUSED
      // YT.PlayerState.BUFFERING
      // YT.PlayerState.CUED
      console.log("Player state changed", e.data);
      if (e.data === YT.PlayerState.ENDED) {
        if (this.closeHandler) {
          this.closeHandler();
        }
        e.target.playVideo();
      }
    },
  },
};
